import ErrorIcon from '@mui/icons-material/Error';
import { Fab, Grid, InputLabel, Select, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import LightTheme from '../themes/LightTheme';
import { TEXT_VARIANTS } from '../themes/MaterialTheme';

export const StyledFab = styled(Fab)({
    height: '26px',
    width: '26px',
    minHeight: '26px',
    verticalAlign: 'bottom'
});

export const StyledButtonContainer = styled('div')({
    marginTop: '30px'
});

export const StyledInputLabel = styled(InputLabel)({
    color: TEXT_VARIANTS.primary,
    lineHeight: '19px',
    marginBottom: '5px'
});

export const StyledTextField = styled(TextField)({
    minWidth: '135px',
    height: '32px',
    borderRadius: '4px',
    marginRight: '12px'
});

// Make select box same height as text fields.
export const StyledSelect = styled(Select)({
    div: {
        paddingTop: '8px',
        paddingBottom: '9px'
    }
});

export const StyledErrorIcon = styled(ErrorIcon)({
    marginRight: '3px',
    fontSize: '15px',
    marginTop: '1px'
});

export const StyledRowContainer = styled('div')({
    verticalAlign: 'middle',
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'space-around',
    minHeight: '65px'
});

export const StyledGridRowContainer = styled(Grid)({
    marginBottom: '10px',
    paddingBottom: '10px',
    borderBottom: `1px solid ${LightTheme.colors.border}`
});

export const StyledFormTitleContainer = styled('div')({
    marginTop: '28px'
});

export const StyledFormTitle = styled(Typography)({
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '32px'
});

export const StyledRoleSelect = styled(Select)({
    minWidth: '220px',
    height: '40px',
    borderRadius: '4px',
    marginRight: '12px'
});
